// @ts-nocheck
import { FC, useContext } from 'react';
import getFormItem from '../hooks/getFormItem';
import { EditableRowContext } from './editableRow';
import { EditableCellProps } from '../interface';

/** 单元格 */
const EditableCell: FC<EditableCellProps> = props => {
  const {
    record,
    editable,
    children,
    rowIndex,
    formItemProps,
    disabledRenderKey,
    mergeRowKey,
    columnIndex,
    tableElement,
    rowRender,
    ...restProps
  } = props;
  const form = useContext(EditableRowContext);
  if (record?.isMainTable && mergeRowKey) {
    if (columnIndex === 0 && Array.isArray(children)) {
      return [children[0], rowRender ? rowRender(record) : record[mergeRowKey]];
    }
    return null;
  }
  return (
    <td {...restProps}>
      {editable
        ? getFormItem(record, tableElement, { ...formItemProps, form, rowIndex, })
        : children}
    </td>
  );
};

export default EditableCell;
